import { Routes } from '@angular/router';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ListPersonsComponent } from './components/persons/list/list-persons.component';
import { LoginComponent } from './components/login/login.component';
import { CreateBackofficeUserComponent } from './components/backoffice-users/create/create-backoffice-user.component';
import { EditBackofficeUserComponent } from './components/backoffice-users/edit/edit-backoffice-user.component';
import { ListBackofficeUsersComponent } from './components/backoffice-users/list/list-backoffice-users.component';
import { EditEditionComponent } from './components/editions/edit/edit-edition.component';
import { CreateEditionComponent } from './components/editions/create/create-edition.component';
import { CreatePersonComponent } from './components/persons/create/create-person.component';
import { EditPersonComponent } from './components/persons/edit/edit-person.component';
import { ListCompaniesComponent } from './components/companies/list/list-companies.component';
import { ViewCompanyComponent } from './components/companies/view/view-company.component';
import { ListQuestionsComponent } from './components/questions/list/list-questions.component';
import { CreateQuestionComponent } from './components/questions/create/create-question.component';
import { EditQuestionComponent } from './components/questions/edit/edit-question.component';
import { ListEditionsComponent } from './components/editions/list/list-editions.component';
import { MsalGuard } from '@azure/msal-angular';
import { ListTouchpointPrivacyConfigurationsComponent } from './components/touchpoint-privacy-configuration/list/list-touchpoint-privacy-configurations.component';
import { CreateTouchpointPrivacyConfigurationComponent } from './components/touchpoint-privacy-configuration/create/create-touchpoint-privacy-configuration.component';
import { EditTouchpointPrivacyConfigurationComponent } from './components/touchpoint-privacy-configuration/edit/edit-touchpoint-privacy-configuration.component';

export const routes: Routes = [
  // login
  { path: 'login', component: LoginComponent },
  // persons
  {
    path: 'persone',
    component: ListPersonsComponent,
    data: { title: 'Persone', roles: ['viewer', 'editor', 'admin', 'owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'persone/create',
    component: CreatePersonComponent,
    data: { title: 'Persone', roles: ['editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  {
    path: 'persone/edit/:id',
    component: EditPersonComponent,
    data: { title: 'Persone', roles: ['viewer', 'editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  // companies
  {
    path: 'aziende',
    component: ListCompaniesComponent,
    data: { title: 'Aziende', roles: ['viewer', 'editor', 'admin', 'owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'aziende/view/:id',
    component: ViewCompanyComponent,
    data: { title: 'Aziende', roles: ['viewer', 'editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  // questions
  {
    path: 'domande',
    component: ListQuestionsComponent,
    data: { title: 'Domande', roles: ['viewer', 'editor', 'admin', 'owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'domande/create',
    component: CreateQuestionComponent,
    data: { title: 'Domande', roles: ['editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  {
    path: 'domande/edit/:id',
    component: EditQuestionComponent,
    data: { title: 'Domande', roles: ['viewer', 'editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  // editions
  {
    path: 'edizioni',
    component: ListEditionsComponent,
    data: { title: 'Edizioni', roles: ['viewer', 'editor', 'admin', 'owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'edizioni/create',
    component: CreateEditionComponent,
    data: { title: 'Edizioni', roles: ['editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  {
    path: 'edizioni/edit/:editionCode',
    component: EditEditionComponent,
    data: { title: 'Edizioni', roles: ['viewer', 'editor', 'admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  // backoffice-users
  {
    path: 'utenti-backoffice',
    component: ListBackofficeUsersComponent,
    data: { title: 'Utenti backoffice', roles: ['owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'utenti-backoffice/create',
    component: CreateBackofficeUserComponent,
    data: { title: 'Utenti backoffice', roles: ['owner'] },
    canActivate: [MsalGuard],
  },
  {
    path: 'utenti-backoffice/edit/:email',
    component: EditBackofficeUserComponent,
    data: { title: 'Utenti backoffice', roles: ['owner'] },
    canActivate: [MsalGuard],
  },
  // touchpoint-privacy-configuration
  {
    path: 'configurazioni-tp',
    component: ListTouchpointPrivacyConfigurationsComponent,
    data: { title: 'Configurazioni TP', roles: ['admin', 'owner'], canChangeEntity: true },
    canActivate: [MsalGuard],
  },
  {
    path: 'configurazioni-tp/create',
    component: CreateTouchpointPrivacyConfigurationComponent,
    data: { title: 'Configurazione TP', roles: ['admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  {
    path: 'configurazioni-tp/edit/:id',
    component: EditTouchpointPrivacyConfigurationComponent,
    data: { title: 'Configurazione TP', roles: ['admin', 'owner'] },
    canActivate: [MsalGuard],
  },
  // others
  { path: '', redirectTo: '/persone', pathMatch: 'full' },
  { path: '**', redirectTo: '/persone', pathMatch: 'full' },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
];
